jQuery('.gutter-edge-kit-checkbox-5m').click(function(e) {
  if($('input.gutter-edge-kit-checkbox-5m').is(':checked')){
        $(".gutter-edge-kit-no-5m").addClass("show");
         jQuery('.gutter-edge-kit-no-5m').val('1');
    }
  else{
     $(".gutter-edge-kit-no-5m").removeClass("show");
     jQuery('.gutter-edge-kit-no-5m').val('');
  }
  }); 

jQuery('.gutter-edge-kit-checkbox-10m').click(function(e) {
  if($('input.gutter-edge-kit-checkbox-10m').is(':checked')){
        $(".gutter-edge-kit-no-10m").addClass("show");
         jQuery('.gutter-edge-kit-no-10m').val('1');
    }
  else{
     $(".gutter-edge-kit-no-10m").removeClass("show");
     jQuery('.gutter-edge-kit-no-10m').val('');
  }
  }); 

jQuery('.gutter-edge-kit-checkbox-15m').click(function(e) {
  if($('input.gutter-edge-kit-checkbox-15m').is(':checked')){
        $(".gutter-edge-kit-no-15m").addClass("show");
         jQuery('.gutter-edge-kit-no-15m').val('1');
    }
  else{
     $(".gutter-edge-kit-no-15m").removeClass("show");
     jQuery('.gutter-edge-kit-no-15m').val('');
  }
}); 

jQuery('.gutter-edge-kit-checkbox-30m').click(function(e) {
  if($('input.gutter-edge-kit-checkbox-30m').is(':checked')){
        $(".gutter-edge-kit-no-30m").addClass("show");
         jQuery('.gutter-edge-kit-no-30m').val('1');
    }
  else{
     $(".gutter-edge-kit-no-30m").removeClass("show");
     jQuery('.gutter-edge-kit-no-30m').val('');
  }
}); 





jQuery('.valley-checkbox-5m').click(function(e) {
  if($('input.valley-checkbox-5m').is(':checked')){
      $(".valley-no-5m").addClass("show");
       jQuery('.valley-no-5m').val('1');
  }
  else{
     $(".valley-no-5m").removeClass("show");
     jQuery('.valley-no-5m').val('');
  }
}); 

jQuery('.valley-checkbox-10m').click(function(e) {
  if($('input.valley-checkbox-10m').is(':checked')){
      $(".valley-no-10m").addClass("show");
       jQuery('.valley-no-10m').val('1');
  }
  else{
     $(".valley-no-10m").removeClass("show");
     jQuery('.valley-no-10m').val('');
  }
}); 

jQuery('.valley-checkbox-15m').click(function(e) {
  if($('input.valley-checkbox-15m').is(':checked')){
      $(".valley-no-15m").addClass("show");
       jQuery('.valley-no-15m').val('1');
  }
  else{
     $(".valley-no-15m").removeClass("show");
     jQuery('.valley-no-15m').val('');
  }
}); 

jQuery('.valley-checkbox-30m').click(function(e) {
  if($('input.valley-checkbox-30m').is(':checked')){
      $(".valley-no-30m").addClass("show");
       jQuery('.valley-no-30m').val('1');
  }
  else{
     $(".valley-no-30m").removeClass("show");
     jQuery('.valley-no-30m').val('');
  }
}); 